import { useCountriesQuery } from '@features/redux/apis/org';
import { FormSingleSelect } from './base/FormSingleSelect';

import type { FormComponentProps } from '../types';

type CountrySelectProps<State extends Record<string, any>> = FormComponentProps<State> & {
    idKey: string & keyof State;
};

export const CountrySelect = <State extends Record<string, any>>({ draft }: CountrySelectProps<State>) => {
    const { data, isLoading } = useCountriesQuery({});

    return (
        <FormSingleSelect
            label='Country'
            draft={draft}
            options={data?.map(({ countryName }) => ({ name: countryName, id: countryName })) ?? []}
            includeAll={false}
            idKey='Country'
            nameKey='Country'
            disable={isLoading}
            size={12}
        />
    );
};
